import { Form } from "antd"
import { useCallbackRef } from "../../../../hooks/use-callback-ref.ts"
import { type FormInstance } from "antd/es/form/hooks/useForm"
import { useEffect } from "react"

import { isFormChanged } from "../../../../utils/object/is-form-changed.ts"
import { type SettingsCompanyFormData } from "./SettingsCompanyForm.tsx"

interface SettingsCompanyFormChangedWatcherProps {
  form: FormInstance<SettingsCompanyFormData>
  initialValues?: SettingsCompanyFormData
  setIsDirty: (value: boolean) => void
  saving: boolean
}

export function SettingsCompanyFormChangedWatcher({
  form,
  initialValues,
  setIsDirty,
  saving
}: SettingsCompanyFormChangedWatcherProps) {
  const values = Form.useWatch([], form)
  const getLogoUrl = (logo: SettingsCompanyFormData["logo"]) =>
    typeof logo === "string" ? logo?.split("?")?.[0] : logo

  const setIsDirtyLatest = useCallbackRef(setIsDirty)
  useEffect(() => {
    const isChanged = isFormChanged<SettingsCompanyFormData>(
      { ...values, logo: getLogoUrl(values?.logo) },
      { ...initialValues, logo: getLogoUrl(initialValues?.logo) }
    )

    setIsDirtyLatest(isChanged)
  }, [values, saving, setIsDirtyLatest, initialValues])

  return null
}
